(() => {
  if (window.BlakoProductPageLoaded) return;
  window.BlakoProductPageLoaded = true;

  const getCurrentPriceText = (productInfo) => {
    if (!productInfo) return '';
    const salePrice = productInfo.querySelector('.blako-product-price .price__sale .price-item--last');
    const regularPrice = productInfo.querySelector('.blako-product-price .price__regular .price-item--regular');
    const activeSale = salePrice && window.getComputedStyle(salePrice.closest('.price__sale')).display !== 'none';
    const node = activeSale ? salePrice : regularPrice || salePrice;
    return node?.textContent?.trim() || '';
  };

  const updateSubmitLabel = (productInfo) => {
    if (!productInfo) return;
    const button = productInfo.querySelector('.product-form__submit');
    if (!button || button.disabled) return;

    const textNode = button.querySelector('[data-blako-product-submit-text]') || button.querySelector('span');
    if (!textNode) return;

    const price = getCurrentPriceText(productInfo);
    textNode.setAttribute('data-blako-product-submit-text', '');
    textNode.classList.add('blako-product-submit__text');
    textNode.textContent = price ? `${window.variantStrings.addToCart} — ${price}` : window.variantStrings.addToCart;
  };

  const updateStockStatus = (productInfo, variant) => {
    if (!productInfo) return;
    const status = productInfo.querySelector('[data-blako-product-stock-status]');
    if (!status) return;

    const isUnavailable = variant ? variant.available === false : productInfo.querySelector('.blako-product-price .price')?.classList.contains('price--sold-out');
    status.classList.toggle('is-hidden', !isUnavailable);
  };

  const updateAll = () => {
    document.querySelectorAll('product-info.blako-main-product').forEach((productInfo) => {
      updateSubmitLabel(productInfo);
      updateStockStatus(productInfo);
    });
  };

  document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  document.addEventListener('shopify:section:load', updateAll);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      requestAnimationFrame(() => {
        updateSubmitLabel(productInfo);
        updateStockStatus(productInfo, data.variant);
      });
    });
  }
})();
